import ServiceBase from "./ServiceBase"

const resource = "/persons"

export default
	{
		getPersons(payload)
		{
			return ServiceBase.get(resource + "/list/" + payload.customerid + "/" +
				(payload.persongroupid ? payload.persongroupid : "0") +
				(payload.persontype ? "/" + payload.persontype : "/0") + 
				(payload.agreementid ? "/" + payload.agreementid : ""))
		},
		updatePersonMediaFiles(payload)
		{
			return ServiceBase.post(resource + "/updatemedia/" + payload.personid, payload.formData,
				{
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}).then(uploadResponse =>
				{
					return uploadResponse
				})
		},
		getPersonsByGroup(groupId)
		{
			return ServiceBase.get(resource + "/group/" + groupId)
		},
		getPerson(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updatePerson(payload)
		{
			return ServiceBase.put(resource + "/" + payload.id, payload)
		},
		addPerson(payload)
		{
			return ServiceBase.post(resource, payload)
		},
		deletePerson(id)
		{
			return ServiceBase.delete(resource + "/" + id)
		},
		importPersonsAndGroups(customerId, agreementId, action, payload)
		{
			return ServiceBase.post(resource + "/import/" + customerId + "/" + agreementId + "/" + action, payload,
				{
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}
			)
		},
		getOrderingPDF(personid)
		{
			return ServiceBase.get(resource + "/pdf/" + personid,
				{
					responseType: "arraybuffer"
				})
				.then(response =>
				{
					let blob = new Blob([response.data], { type: 'application/pdf' }),url = window.URL.createObjectURL(blob)
					window.open(url)
				}
			)
		},
		resetPersonStatus(payload)
		{
			return ServiceBase.get(resource + "/updatepersonstatus/" + payload.personid + "/" + payload.status)
		}
	}